
import React from "react";
import "./hero.css";
import MorphingShape from "./MorphingShape";

export default function Hero() {
  return (
    <main>
      <section className="hero">
        <div className="left">
          {/* <h1 className="soft-rainbow">
            Creative Design & Smart Marketing That Grows Your Business.
          </h1> */}
          <h1 className="title1 soft-rainbow">
            Creative Design <br></br> and Smart Marketing <br></br> 
            <span className="gradientWord"> That Grows Your Business.</span>
          </h1>
          <p>"Ready to grow your business ? — Let's talk"</p>
        </div>

        <div className="Right">
          <div className="hero-visual">
            <MorphingShape />
          </div>

        </div>
      </section>
    </main>
  );
}